import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Container, NavigationScroll } from '@uncinc/uncinc-react-kitchen-sink';

import {
  MenuMain,
  MenuMainOverlay,
} from '../../../implementations';
import { ReactComponent as LogoSVG } from '../../../assets/images/rgb-jubileum-logo.svg';

import '../style.scss';

const VriendenvanderegenboogHeader = () => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);
  const [overlayMenuVisible, setOverlayMenuVisible] = useState(false);
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  // Prevent overlay from being displayed initially.
  window.addEventListener('load', () => {
    setLoaded(true);
  });

  useEffect(() => {
    document.body.classList.toggle('Header__overlay--body', overlayMenuVisible);
  }, [overlayMenuVisible]);

  const classes = c({
    expanded: overlayMenuVisible,
    preload: !loaded,
  });

  return (
    <NavigationScroll>
      <header className={classes}>
        <Container className="Header__container">
          <div className="row">

            <div className="Header__logo col-2">
              <CoreLink
                href={currentLanguage === 'nl' ? '/' : `/${currentLanguage}`}
                onClick={() => setOverlayMenuVisible(false)}
                ariaLabel={t('general.image_company')}
              >
                <div className="Header__logo__img">
                  <LogoSVG />
                </div>
              </CoreLink>
            </div>

            <div className="Header col-10">
              <div className="Header__menu">
                <div className="Header__menu__primary">
                  <MenuMain setOverlayMenuVisible={setOverlayMenuVisible} id="vriendenvanderegenboog-main" />
                </div>
              </div>
              <div className="Header__buttons">
                <button
                  type="button"
                  onClick={() => {
                    setOverlayMenuVisible(!overlayMenuVisible);
                  }}
                  aria-label={overlayMenuVisible ? t('menu.close_menu') : t('menu.open_menu')}
                >
                  <div
                    className={`icon icon-${overlayMenuVisible ? 'cross' : 'hamburger'}`}
                  />
                </button>
              </div>
            </div>
          </div>
        </Container>
        <div className="Header__overlay">
          <Container>
            <div className="row">
              <div className="col-12 Header__overlay__main_menu order-2 order-lg-1">
                <MenuMainOverlay
                  onClick={() => setOverlayMenuVisible((prevMenuActive) => !prevMenuActive)}
                  setOverlayMenuVisible={setOverlayMenuVisible}
                  overlayMenuVisible={overlayMenuVisible}
                  id="vriendenvanderegenboog-main"
                />
              </div>
            </div>
          </Container>
        </div>
      </header>
    </NavigationScroll>
  );
};

export default VriendenvanderegenboogHeader;
